import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Input } from "../components/ui/input";
import { Activity, Search, User, Clock } from "lucide-react";

const ACTION_LABELS = {
  promote_sub_admin: "Promozione sub-admin",
  demote_sub_admin: "Rimozione sub-admin",
  invite_sub_admin: "Invito sub-admin",
  broadcast_document: "Invio documento massivo",
  qr_created: "QR generato",
  qr_deleted: "QR eliminato",
  employee_approved: "Dipendente approvato",
};

export default function AuditLogPage() {
  const [logs, setLogs] = useState([]);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    api.get("/audit-logs?limit=300").then((r) => setLogs(r.data));
  }, []);

  const filtered = logs.filter((l) => {
    if (!filter) return true;
    const q = filter.toLowerCase();
    return (l.actor_email || "").toLowerCase().includes(q) || (l.action || "").toLowerCase().includes(q);
  });

  return (
    <div className="p-4 md:p-12" data-testid="audit-log-page">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-widest text-[#757575] mb-2">Sicurezza · Compliance</div>
        <h1 className="font-display text-4xl">Audit log</h1>
        <p className="text-[#555] mt-1 text-sm">Chi ha fatto cosa, quando. Conservato 12 mesi · accesso solo admin.</p>
      </div>

      <div className="relative mb-6 max-w-md">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#999]"/>
        <Input
          placeholder="Filtra per email o azione…"
          className="rounded-xl pl-9"
          value={filter}
          onChange={(e)=>setFilter(e.target.value)}
          data-testid="audit-filter"
        />
      </div>

      <div className="card-smart overflow-hidden">
        <table className="w-full text-sm">
          <thead className="border-b border-[#EDE5D8] sticky top-0 bg-white">
            <tr className="text-left">
              <th className="p-4 font-semibold">Quando</th>
              <th className="p-4 font-semibold">Chi</th>
              <th className="p-4 font-semibold">Azione</th>
              <th className="p-4 font-semibold">Risorsa</th>
              <th className="p-4 font-semibold">Dettagli</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr><td colSpan="5" className="p-12 text-center text-[#757575]"><Activity className="w-10 h-10 mx-auto mb-2 text-[#FF7A29]/50"/>Nessun evento registrato.</td></tr>
            ) : filtered.map((l) => (
              <tr key={l.id} className="border-b border-[#EDE5D8] hover:bg-[#FFF0E3]/30" data-testid={`audit-${l.id}`}>
                <td className="p-4 text-xs text-[#555] whitespace-nowrap">
                  <Clock className="w-3 h-3 inline mr-1"/>
                  {new Date(l.timestamp).toLocaleString("it-IT")}
                </td>
                <td className="p-4">
                  <div className="font-semibold text-xs flex items-center gap-1"><User className="w-3 h-3"/>{l.actor_email}</div>
                  <div className="text-[10px] uppercase tracking-widest text-[#FF7A29] mt-0.5">{l.actor_role}</div>
                </td>
                <td className="p-4 font-mono text-xs">
                  <span className="bg-[#FFF0E3] text-[#E85D00] px-2 py-0.5 rounded-full font-semibold">
                    {ACTION_LABELS[l.action] || l.action}
                  </span>
                </td>
                <td className="p-4 text-xs text-[#555] font-mono">{l.resource_type || "—"}{l.resource_id ? ` · ${l.resource_id.slice(0,8)}` : ""}</td>
                <td className="p-4 text-xs text-[#555] max-w-xs truncate font-mono">{JSON.stringify(l.details || {}).slice(0, 100)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
